import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import LangLayout from './components/LangLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import { initGA, trackPageView } from './utils/analytics';
import { SUPPORTED_LANGS, pathPrefix, stripLangPrefix } from './i18n/config';
import i18n from './i18n';

// 言語ごとに展開するページ定義。1箇所で管理し、言語分ループする。
const pageRoutes = [
  { path: '', element: <HomePage /> },
  { path: 'about', element: <AboutPage /> },
  { path: 'news', element: <NewsPage /> },
  { path: 'news/:id', element: <NewsDetailPage /> },
];

// ページビュー追跡用コンポーネント
function AnalyticsWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    // 言語プレフィックスを除いたパスでページタイトルを決める
    const getPageTitle = (pathname) => {
      const { lang, rest } = stripLangPrefix(pathname);
      const t = i18n.getFixedT(lang);

      switch (rest) {
        case '/':
          return t('meta.home.title');
        case '/about':
          return t('meta.about.title');
        case '/news':
          return t('meta.news.title');
        default:
          if (rest.startsWith('/news/')) {
            const newsId = rest.split('/news/')[1];
            return t('meta.newsDetail.title', { title: `#${newsId}` });
          }
          return t('meta.home.title');
      }
    };

    trackPageView(location.pathname, getPageTitle(location.pathname));

    // ページ上部にスクロール
    window.scrollTo(0, 0);
  }, [location]);

  return children;
}

// ルート定義。Routerを含まないため、テストからは MemoryRouter で包んで使える。
export function AppRoutes() {
  return (
    <AnalyticsWrapper>
      <Routes>
            {SUPPORTED_LANGS.map((lang) => (
              <Route key={lang} path={pathPrefix(lang) || '/'} element={<LangLayout lang={lang} />}>
                {pageRoutes.map((route) =>
                  route.path === '' ? (
                    <Route key="index" index element={route.element} />
                  ) : (
                    <Route key={route.path} path={route.path} element={route.element} />
                  )
                )}
                {/* その言語配下の未知パス（例 /en/foo）を404にする */}
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            ))}
      </Routes>
    </AnalyticsWrapper>
  );
}

function App() {
  // Google Analytics初期化（アプリ起動時に一度だけ実行）
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <div className="App">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;
